export interface CrossoverScreenSelection {
    choice: number;
    millisecondsSinceFirstRender: number;
    defaultOption: number;
}

export interface CrossoverScreenResult {
    selections: CrossoverScreenSelection[];
}

export const CrossoverScreenInitialResult: CrossoverScreenResult = {
    selections: []
};